import { 
    distanseBetweenLayers, 
    getCenteredCoordinateForAnimation, 
    BallPositionByDot, 
    parabolic,
    PARABOLIC_TIME
} from '../../initials';
export class Parabolic {
    constructor({
        fromRowIndex,
        fromDotIndex,
        toRowIndex,
        toDotIndex,
        dots,
    }) {
        this.fromRowIndex = fromRowIndex;
        this.fromDotIndex = fromDotIndex;
        this.toRowIndex = toRowIndex;
        this.toDotIndex = toDotIndex;
        this.dots = dots;
    }

    static getAnimationSettings() {
        return {
            avaiableForMultipleLevels: false,
            type: 'parabolic',
            fromBallPositionByDot: BallPositionByDot.CENTER,
            toBallPositionByDot: BallPositionByDot.CENTER,
        };
    }

    getAnimationTime() {
        return PARABOLIC_TIME * (this.toRowIndex - this.fromRowIndex);
    }

    animate(time) {
        const fullTime = this.getAnimationTime();
        const t = time / fullTime;

        const startDot = this.dots[this.fromRowIndex][this.fromDotIndex];
        const endDot = this.dots[this.toRowIndex][this.toDotIndex];

        const startXY = getCenteredCoordinateForAnimation(startDot.dotX, startDot.dotY);
        const endXY = getCenteredCoordinateForAnimation(endDot.dotX, endDot.dotY);

        return {
            x: parabolic(
                startXY.x, 
                startXY.x, 
                endXY.x, 
                t,
            ),
            y: parabolic(
                startXY.y, 
                startXY.y - distanseBetweenLayers, 
                endXY.y, 
                t,
            ),
        };
    }
}